import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ineligibleStyles from './IneligibilityPage.scss';
import { HeaderNavigation } from '../../../components/HeaderNavigation';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'app/configureStore';
import { sectionMetadata } from 'client-experience-toolbox';
import { Button } from 'drift-ui';

export const IneligibilityPage: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lockedBy = useSelector((state: RootState) => state?.applicationReducer?.bankingApplication?.lockedBy);
  const onHandleBack = () => {
    navigate('/banking');
  };

  return (
    <>
      <div className={ineligibleStyles.fixedHeader}>
        <HeaderNavigation title={t(sectionMetadata.BANKING?.[lockedBy].title())} hideBackButton />
      </div>

      <div className={ineligibleStyles.ineligibilityContainer}>
        <div className={ineligibleStyles.contentSection}>
          {<p className={ineligibleStyles.body}>{t(`digital_onboarding.banking.ineligible_text`)}</p>}
          <Button variant="contained" onClick={onHandleBack}>
            {t('close')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default IneligibilityPage;
